import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, BehaviorSubject, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpUtilsService } from 'app/core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';
import { environment } from 'environments/environment';

@Injectable()
export class ListDialogService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));

	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	findData_Emp(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		const url = environment.ApiRoot + '/danhmuc/Get_DSNhanVien';
		return this.http.get<QueryResultsModel>(url, {
			headers: httpHeaders,
			params: httpParams
		});
	}
	findData_Product(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		const url = environment.ApiRoot + '/dungchung/List_HangHoa_CoTon';
		return this.http.get<QueryResultsModel>(url, {
			headers: httpHeaders,
			params: httpParams
		});
	}
	findData_ProductWFilter(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		const url = environment.ApiRoot + '/dungchung/List_HangHoa_Filter';
		return this.http.get<QueryResultsModel>(url, {
			headers: httpHeaders,
			params: httpParams
		});
	}
	GetListPositionbyStructure(id): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/danhmuc/GetListPositionbyStructure?structureid=${id}`, { headers: httpHeaders });
	}
	GetListJobtitleByStructure(cd, id): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/danhmuc/GetListJobtitleByStructure?id_cv=${cd}&&structureid=${id}`, { headers: httpHeaders });
	}
	Get_CoCauToChuc(): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + '/danhmuc/DM_PhongBan_Tree', { headers: httpHeaders });
	}
	GetListPositionbyStructure_All(id): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + '/danhmuc/GetListPositionbyStructure_All', { headers: httpHeaders });
	}
	GetListJobtitleByStructure_All(cd,id): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + '/danhmuc/GetListJobtitleByStructure_All', { headers: httpHeaders });
	}
	GetListBranchbyCustomerID(): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + '/danhmuc/GetListBranchbyCustomerID', { headers: httpHeaders });
	}
	GetListDepartmentbyBranch(id): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + '/danhmuc/GetListDepartmentbyBranch', { headers: httpHeaders });
	}
	GetListTeamByDepartment(id): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + '/danhmuc/GetListTeamByDepartment', { headers: httpHeaders });
	}
	GetListPositionbyDepartment(id): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + '/danhmuc/GetListPositionbyDepartment', { headers: httpHeaders });
	}
	GetListJobtitleByPosition(cd,id): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + '/danhmuc/GetListJobtitleByPosition', { headers: httpHeaders });
	}
	listKho(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/danhmuc' + '/Kho_List';
		return this.http.get<any>(url, { headers: httpHeaders });
	}
}
